import { FOCUS_MODE_EVENTS } from '../constants/actionTypes';

export const initialState = {
  isFocusMode: false,
};

const foucusModeReducer = (state, { type, payload }) => {
  switch (type) {
    case FOCUS_MODE_EVENTS.SUCCESS: {
      return { isFocusMode: payload };
    }

    case FOCUS_MODE_EVENTS.RESET:
      return initialState;

    default:
      return state;
  }
};

export default foucusModeReducer;
